import * as React from 'react';
import AccessibleSVG from 'box-ui-elements/es/icons/accessible-svg';

type Props = {
  className?: string;
  height?: number;
  /** A text-only string describing the icon if it's not purely decorative for accessibility */
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  title?: string | React.ReactElement<any>;
  width?: number;
};

const ICON_CLASS = 'upload-illustration';

const UploadIllustration = ({
  className = '',
  height = 141,
  title,
  width = 140,
}: Props) => (
  <AccessibleSVG
    className={`${ICON_CLASS} ${className}`}
    height={height}
    title={title}
    viewBox="0 0 141 140"
    width={width}
  >
    <g
      fill="none"
      fillRule="evenodd"
      transform="translate(0 9)"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g className={`${ICON_CLASS}-stroke`} stroke="#0061D5" strokeWidth="2">
        <path
          d="M32.004 24.819a1.498 1.498 0 0 1 1.218-1.743L55.72 19.11c.817-.144 2.01.159 2.658.67l7.258 5.73c.651.515 1.296 1.593 1.438 2.4l5.882 33.358c.143.81-.41 1.585-1.223 1.729l-30.52 5.381a1.501 1.501 0 0 1-1.743-1.22l-7.466-42.338z"
          fill="#FFF"
        />
        <path
          d="m66.037 26.35-6.606 1.165a1.294 1.294 0 0 1-1.497-1.048l-1.165-6.606"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          className={`${ICON_CLASS}-fill`}
          d="m48.109 34.483 7.308 7.647-11.56 2.038z"
          fill="#0061D5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          className={`${ICON_CLASS}-fill`}
          d="M56.757 36.207l4.826 4.836-7.707 1.359zM55.115 33.654a.791.791 0 0 0 .631-.924.791.791 0 0 0-.91-.652.791.791 0 0 0-.631.924.791.791 0 0 0 .91.652z"
          fill="#0061D5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        className={`${ICON_CLASS}-stroke`}
        d="M5.53 53.884a1.498 1.498 0 0 1 .548-2.053l19.785-11.423c.718-.415 1.942-.539 2.726-.28l8.78 2.903c.788.26 1.762 1.053 2.172 1.762l16.936 29.335c.412.713.157 1.63-.558 2.043L29.081 91.666a1.501 1.501 0 0 1-2.056-.55L5.53 53.884z"
        fill="#FFF"
        stroke="#0061D5"
        strokeWidth="2"
      />
      <path
        className={`${ICON_CLASS}-stroke`}
        d="m38.464 43.464-5.81 3.354a1.294 1.294 0 0 1-1.764-0.473l-3.354-5.81"
        stroke="#0061D5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        className={`${ICON_CLASS}-fill`}
        d="M33.986 66.924a.999.999 0 0 1 1.304.267l.064.098a1.006 1.006 0 0 1-.368 1.368l-8.656 4.997a.999.999 0 1 1-1-1.732l8.656-4.998zm4.844-2.796a1.003 1.003 0 0 1 1.31.263l.064.098a1 1 0 0 1-.374 1.371l-1.716.99a1 1 0 1 1-1-1.732l1.716-.99zm-.406-5.539a.992.992 0 0 1 1.294.272l.065.098a1.003 1.003 0 0 1-.36 1.362L23.822 69.33a.993.993 0 0 1-1.359-.37 1.003 1.003 0 0 1 .36-1.362l15.602-9.008zm-2.5-4.33a.992.992 0 0 1 1.294.272l.065.098a1.003 1.003 0 0 1-.36 1.362l-15.602 9.008a.993.993 0 0 1-1.359-.37 1.003 1.003 0 0 1 .36-1.362l15.602-9.008z"
        fill="#0061D5"
      />
      <path
        className={`${ICON_CLASS}-stroke`}
        d="M70.47 19.915a1.498 1.498 0 0 1 1.74-1.221l22.498 3.967c.817.144 1.834.836 2.268 1.539l4.86 7.867c.437.705.674 1.939.531 2.745l-5.881 33.359a1.501 1.501 0 0 1-1.741 1.206l-30.52-5.381a1.501 1.501 0 0 1-1.22-1.743l7.465-42.338z"
        fill="#FFF"
        stroke="#0061D5"
        strokeWidth="2"
      />
      <path
        className={`${ICON_CLASS}-stroke`}
        d="m102.18 33.762-6.144-1.187a1.294 1.294 0 0 1-1.048-1.497l1.165-6.606"
        stroke="#0061D5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        className={`${ICON_CLASS}-fill`}
        d="m83.58 50.439c5.412 0 9.8-4.388 9.8-9.8 0-5.413-4.388-9.8-9.8-9.8-5.413 0-9.8 4.387-9.8 9.8 0 5.412 4.387 9.8 9.8 9.8zm0-1.6a8.2 8.2 0 1 1 0-16.4 8.2 8.2 0 0 1 0 16.4z"
        fill="#0061D5"
        fillRule="nonzero"
      />
      <path
        className={`${ICON_CLASS}-stroke ${ICON_CLASS}-fill`}
        d="m86.46 41.012-4.46 2.26 1.042-5.91z"
        fill="#0061D5"
        stroke="#0061D5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <g className={`${ICON_CLASS}-stroke`} stroke="#0061D5">
        <path
          d="M105.025 36.884a1.498 1.498 0 0 1 2.053-.552l19.785 11.423c.718.415 1.437 1.413 1.605 2.222l1.876 9.054c.169.813-.03 2.053-.44 2.762l-16.936 29.335a1.501 1.501 0 0 1-2.049.538L84.081 76.171a1.501 1.501 0 0 1-.551-2.055l21.495-37.232z"
          fill="#FFF"
          strokeWidth="2"
        />
        <path
          d="m129.87 59.57-5.81-3.354a1.294 1.294 0 0 1-0.472-1.765l3.354-5.81"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <g fill="#FFF" strokeWidth="1.6">
          <path d="m104.84 52.938 3.948 2.28-2.334 4.041-3.948-2.28zm-2.334 4.042 3.948 2.28-2.333 4.04-3.948-2.279z" />
          <path d="m100.17 61.02 3.948 2.28-2.333 4.042-3.948-2.28zm8.615-5.803 12.597 7.273-2.334 4.041-12.596-7.272zm-2.333 4.042 12.596 7.272-2.333 4.042-12.597-7.273z" />
          <path d="m104.12 63.3 12.597 7.273-2.333 4.041-12.597-7.272z" />
        </g>
      </g>
      <path
        className={`${ICON_CLASS}-fill`}
        d="M126.152 85.52l.07.007a.315.315 0 0 1 .245.302v.404a.633.633 0 0 1 .23.23h.405a.31.31 0 0 1 .31.315l-.01.07a.314.314 0 0 1-.3.245h-.405a.633.633 0 0 1-.23.23v.396c0 .173-.141.318-.315.318l-.07-.008a.314.314 0 0 1-.245-.3v-.406a.633.633 0 0 1-.23-.23h-.405a.31.31 0 0 1-.309-.315l.008-.07a.314.314 0 0 1 .301-.245h.405a.633.633 0 0 1 .23-.23v-.405a.31.31 0 0 1 .315-.309zm11.834-9.426l.088.008c.23.042.415.244.415.487v.647c.153.088.28.216.37.369h.647c.277 0 .494.225.494.503l-.008.088a.503.503 0 0 1-.486.416h-.648c-.088.153-.216.28-.369.369v.633a.51.51 0 0 1-.503.508l-.089-.008a.503.503 0 0 1-.415-.486v-.647a1.012 1.012 0 0 1-.369-.37h-.647a.496.496 0 0 1-.494-.503l.008-.088a.503.503 0 0 1 .486-.415h.647c.089-.153.216-.28.37-.37v-.647c0-.278.225-.494.503-.494zM2.014 71.058l.089.008c.23.042.415.244.415.488v.646c.152.088.28.216.368.368l.648.001c.278 0 .494.225.494.504l-.008.088a.503.503 0 0 1-.486.415l-.648.001c-.088.153-.216.28-.368.368v.633a.51.51 0 0 1-.504.509l-.088-.008a.503.503 0 0 1-.415-.486v-.648a1.012 1.012 0 0 1-.369-.368H.494A.496.496 0 0 1 0 73.072l.008-.089a.503.503 0 0 1 .486-.415h.648c.089-.153.216-.28.369-.369v-.648c0-.277.225-.494.503-.494zM128.606 34.27l.07.008a.315.315 0 0 1 .245.302v.404a.633.633 0 0 1 .23.23h.405a.31.31 0 0 1 .309.315l-.008.07a.314.314 0 0 1-.3.245h-.406a.633.633 0 0 1-.23.23v.396c0 .173-.141.318-.315.318l-.07-.008a.314.314 0 0 1-.245-.3v-.406a.633.633 0 0 1-.23-.23h-.405a.31.31 0 0 1-.309-.315l.008-.07a.314.314 0 0 1 .3-.245h.406a.633.633 0 0 1 .23-.23v-.405a.31.31 0 0 1 .315-.309zM9.579 31.852l.088.008c.23.042.416.244.416.487v.647c.152.088.28.216.368.369h.648c.278 0 .494.225.494.503l-.008.089a.503.503 0 0 1-.486.415h-.648c-.088.153-.216.28-.369.369v.633a.51.51 0 0 1-.503.509l-.088-.008a.503.503 0 0 1-.416-.486v-.648a1.012 1.012 0 0 1-.369-.37H8.06a.496.496 0 0 1-.494-.503l.008-.088a.503.503 0 0 1 .486-.415h.648c.088-.153.216-.28.369-.37v-.647c0-.277.225-.494.503-.494zm8.812-7.05l.07.008a.315.315 0 0 1 .245.302v.404a.633.633 0 0 1 .23.23h.405a.31.31 0 0 1 .31.315l-.01.07a.314.314 0 0 1-.3.245h-.405a.633.633 0 0 1-.23.23v.396c0 .173-.141.318-.315.318l-.07-.008a.314.314 0 0 1-.245-.3v-.406a.633.633 0 0 1-.23-.23h-.405a.31.31 0 0 1-.309-.315l.008-.07a.314.314 0 0 1 .301-.245h.405a.633.633 0 0 1 .23-.23v-.405a.31.31 0 0 1 .315-.309zm83.389-13.128l.088.008c.23.042.415.244.415.488v.647c.153.088.28.215.368.367h.649c.277 0 .494.226.494.504l-.008.089a.503.503 0 0 1-.486.415h-.649c-.088.153-.215.28-.367.368v.634a.51.51 0 0 1-.504.509l-.089-.008a.503.503 0 0 1-.415-.486v-.649a1.012 1.012 0 0 1-.368-.367l-.649-.001a.496.496 0 0 1-.494-.504l.008-.088a.503.503 0 0 1 .486-.415h.649c.088-.153.215-.28.367-.368l.001-.649c0-.277.225-.494.504-.494zM49.317 4.135l.089.008c.23.042.415.244.415.487v.647c.152.088.28.215.368.368h.648c.278 0 .494.226.494.504l-.008.089a.503.503 0 0 1-.486.415h-.647c-.089.153-.216.28-.37.369v.633a.51.51 0 0 1-.503.509l-.088-.008a.503.503 0 0 1-.415-.486v-.648a1.012 1.012 0 0 1-.37-.37h-.647a.496.496 0 0 1-.494-.503l.008-.088a.503.503 0 0 1 .486-.415l.648-.001c.089-.153.216-.28.369-.368v-.648c0-.277.225-.494.503-.494zM75.041 0l.089.008c.23.042.415.244.415.487v.647c.153.088.28.216.369.369h.648c.277 0 .493.225.493.503l-.007.089a.503.503 0 0 1-.486.415h-.648c-.089.153-.216.28-.37.369v.633a.51.51 0 0 1-.503.508l-.088-.008a.503.503 0 0 1-.415-.486v-.647a1.012 1.012 0 0 1-.37-.37h-.647a.496.496 0 0 1-.494-.503l.008-.088a.503.503 0 0 1 .486-.415h.648c.088-.153.216-.28.369-.37V.495c0-.277.225-.494.503-.494z"
        fill="#0061D5"
      />
      <ellipse
        className={`${ICON_CLASS}-fill-2`}
        cx="70"
        cy="119"
        fill="#E5EFFA"
        rx="32"
        ry="3"
      />
      <path
        d="M63 50c-10.493 0-19 8.507-19 19v.164C38.138 71.536 34 77.285 34 84c0 8.837 7.163 16 16 16h40c8.837 0 16-7.163 16-16 0-6.74-4.167-12.506-10.065-14.863.043-.373.065-.752.065-1.137 0-5.523-4.477-10-10-10-2.336 0-4.484.8-6.186 2.143C76.63 54.11 70.295 50 63 50z"
        fill="#FFF"
      />
      <path
        className={`${ICON_CLASS}-fill-2`}
        d="M64.11 92.419c10.105 0 16.473 4.067 22.871 4.067s10.859 0 18.666-8.449c0 0-1.795 4.385-5.474 7.644C97.17 98.342 92.486 100 90 100H50c-8.837 0-16-7.163-16-16 0-.887.072-1.758.211-2.606C44 101.51 54.005 92.42 64.111 92.42z"
        fill="#E5EFFA"
      />
      <path
        className={`${ICON_CLASS}-stroke`}
        d="M63 50c-10.493 0-19 8.507-19 19v.164C38.138 71.536 34 77.285 34 84c0 8.837 7.163 16 16 16h40c8.837 0 16-7.163 16-16 0-6.74-4.167-12.506-10.065-14.863.043-.373.065-.752.065-1.137 0-5.523-4.477-10-10-10-2.336 0-4.484.8-6.186 2.143C76.63 54.11 70.295 50 63 50z"
        stroke="#0061D5"
        strokeWidth="2"
      />
      <path
        className={`${ICON_CLASS}-stroke ${ICON_CLASS}-fill`}
        d="M71.333 82v-5.909H74L70 72l-4 4.09 2.666.001V82h2.667z"
        fill="#0061D5"
        stroke="#0061D5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        className={`${ICON_CLASS}-stroke`}
        d="m70 89c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12z"
        stroke="#0061D5"
        strokeDasharray="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.6"
      />
    </g>
  </AccessibleSVG>
);

export default UploadIllustration;
